import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {checkForPermission, checkForPermissionWithFacility} from './check-permission';
import {GeneralConstant} from '../constants/GeneralConstant';
import {Permission} from '../models/res/permission';
import {PermissionService} from '../services/permission.service';
import {aaaasfRoles, roles} from '../enums/res/roles';
import {TokenService} from '../services/token.service';

@Directive({
  selector: '[appPermissions], [appPermissionsWithFacility]'
})
export class PermissionDirective {
  subscription: any;
  permissions: Permission[] = [];
  permission: string;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService,
    private tokenService: TokenService) {

    this.permissions = JSON.parse(localStorage.getItem(GeneralConstant.PERMISSIONS));

    this.subscription = permissionService.getPermissions().subscribe(response => {
      this.permissions = response;
      this.appPermissions = this.permission;
    });
  }

  @Input() set appPermissions(p: string) {
    this.permission = p;
    const permissionCheck = checkForPermission(p);
    this.viewContainer.clear();
    if (permissionCheck || p === 'true') {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  @Input() set appPermissionsWithFacility(set: {permission: string, facilityId: number}) {
    if (!this.tokenService.getRolesFromToken().includes(roles.STAFF.name)) {
      this.appPermissions = set.permission;
      return;
    }
    const permissionCheck =  checkForPermissionWithFacility(set.permission, set.facilityId);
    this.viewContainer.clear();
    if (permissionCheck || set.permission === 'true') {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
